<template>
  <div class="uploader">
    <uploader-btn v-show="false" :options="options" />
    <slot></slot>
    <uploader-list
      :options="options"
      :file-list="fileList"
      :uploaded-files="uploadedFiles"
      :disabled="options.disabled"
      @remove-file="removeFile"
      @real-file-success="handleRealFileSuccess"
      @upload-error="handleUploadError"
    ></uploader-list>
  </div>
</template>

<script>
import Uploader from "simple-uploader.js";
// import UploaderBtn from "./btn.vue";
// import UploaderList from "./list.vue";
// import UploaderFile from "./file.vue";

import { kebabCase } from "./utils";
import { computeMD5 } from "../../helpers/common";

const FILE_ADDED_EVENT = "fileAdded";
const FILES_ADDED_EVENT = "filesAdded";
const UPLOAD_START_EVENT = "uploadStart";

export default {
  name: "uploader",
  components: {},
  provide() {
    return {
      uploader: this
    };
  },
  props: {
    options: {
      type: Object,
      default() {
        return {
          disabled: false,
          autoStart: true,
          singleFile: false,
          buttonText: "",
          accept: "xls"
        };
      }
    },
    uploadedFiles: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      started: false,
      files: [],
      fileList: []
    };
  },
  methods: {
    handleRealFileSuccess() {
      this.$emit("real-file-success");
    },
    handleUploadError(e) {
      this.$emit("upload-error", e);
    },
    removeFile(file) {
      this.$emit("remove-file", file);
    },

    getFileList() {
      const fileList = [...this.fileList, ...this.uploadedFiles];
      return fileList.map(o => ({ ...o, ...{ path: o.path || "" } }));
    },

    uploadStart() {
      this.started = true;
    },

    async fileAdded(file) {
      await computeMD5(file);
      this.$emit(kebabCase(FILE_ADDED_EVENT), file);

      if (file.ignored) {
        // is ignored, filter it
        return false;
      }
    },

    filesAdded(files, fileList) {
      this.$emit(kebabCase(FILES_ADDED_EVENT), files, fileList);
      if (files.ignored || fileList.ignored) {
        // is ignored, filter it
        return false;
      }
    },

    fileRemoved() {
      this.files = this.uploader.files;
      this.fileList = this.uploader.fileList;
    },

    filesSubmitted() {
      this.files = this.uploader.files;
      this.fileList = this.uploader.fileList;
      if (!this.options.autoStart) {
        this.uploader.upload();
      }
    },

    allEvent(...args) {
      const name = args[0];
      const EVENTSMAP = {
        [FILE_ADDED_EVENT]: true,
        [FILES_ADDED_EVENT]: true,
        [UPLOAD_START_EVENT]: "uploadStart"
      };
      const handler = EVENTSMAP[name];
      if (handler) {
        if (handler === true) {
          return;
        }
        this[handler].apply(this, args.slice(1));
      }
      args[0] = kebabCase(name);
      this.$emit.apply(this, args);
    }
  },
  created() {
    this.options.initialPaused = !this.options.autoStart;
    const uploader = new Uploader(this.options);
    this.uploader = uploader;
    uploader.on("catchAll", this.allEvent);
    uploader.on(FILE_ADDED_EVENT, this.fileAdded);
    uploader.on(FILES_ADDED_EVENT, this.filesAdded);
    uploader.on("fileRemoved", this.fileRemoved);
    uploader.on("filesSubmitted", this.filesSubmitted);
  },
  destroyed() {
    const uploader = this.uploader;
    uploader.off("catchAll", this.allEvent);
    uploader.off(FILE_ADDED_EVENT, this.fileAdded);
    uploader.off(FILES_ADDED_EVENT, this.filesAdded);
    uploader.off("fileRemoved", this.fileRemoved);
    uploader.off("filesSubmitted", this.filesSubmitted);
    this.uploader = null;
  }
};
</script>

<style>
.uploader {
  position: relative;
}
</style>
